import $ from 'jquery'
import { exists } from './helpers'
import { Curtain } from './curtain'
import { PopMenu } from './pop-menu'
import { isMediaActive } from './viewport'

const debug = require('debug')('pm:popup')
debug('loaded')

export const Popup = {
  init: function () {
    debug('init')
    const popupMarkup =
      '<div id="popup" class="u-is-loading hidden"><a href="#" class="b-close-popup hidden">Close</a><div class="wrapper"></div></div>'

    if (!exists('#popup')) {
      $('#curtain').append(popupMarkup)
    }

    $(document)
      .off('click.popup touchend.popup', '.js-popup', Popup.popupHandler)
      .on('click.popup touchend.popup', '.js-popup', Popup.popupHandler)

    $(document).on(
      'click touchend',
      '#popup .b-close-popup, .js-close-popup',
      Popup.close
    )

    // Esc key close event
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27 && !$('#popup').isHidden()) Popup.close(e)
    })
  },

  popupHandler: function (event) {
    debug('popupHandler')
    event.preventDefault()

    if (!$(this).hasClass('js-popup-disable')) {
      $('#popup').addClass($(this).data('container-class'))

      Popup.open()
      Popup.fetch($(this).attr('href'))
    }
  },

  open: function () {
    debug('open')
    // Close any open popovers
    PopMenu.closeAll()

    Curtain.show()
    $('#popup').showMe()
    Popup.refresh()
    $('body').css({ overflow: 'hidden' })
  },

  fetch: function (url) {
    debug('fetch - start', url)

    $('#popup').addClass('u-is-loading')
    $.get(url, '', function (response) {
      debug('fetch - success', { url, response })
      Popup.showContent(response)
    }).always(() => {
      $('#popup').removeClass('u-is-loading')
    })
  },

  showContent: function (html) {
    debug('showContent()', { html })

    $('#popup .wrapper').html(html)
    $('#popup').removeClass('u-is-loading').find('.b-close-popup').showMe()
    Popup.refresh()

    $('#popup').trigger({
      type: 'popupContentLoaded',
      time: new Date(),
    })
  },

  close: function (event) {
    debug('close()')
    event.preventDefault()

    $('#popup').trigger('popupClosing')

    Curtain.hide()
    $('body').removeAttr('style')
    $('#popup .wrapper').html('')
    $('#popup')
      .hideMe()
      .removeClass('u-is-loading')
      .find('.b-close-popup')
      .hideMe()

    $('#popup').trigger({
      type: 'popupCloseEvent',
      time: new Date(),
    })
  },

  refresh: function () {
    const $popup = $('#popup')

    // Only use inline CSS positioning on medium viewports and above
    if (isMediaActive('m')) {
      const popupHeight = $popup.height() + 25
      const windowHeight = $(window).height()

      // Check if popup is larger than window
      if (windowHeight < popupHeight) {
        $popup.css({ top: '20px' })
        $popup.centerHorizontal()
      } else {
        $popup.centerize()
      }
    } else {
      $popup.removeAttr('style')
    }
  },

  showError: function (message) {
    message = message || 'Yikes! There was an error. Please try again.'
    Popup.showContent($('<p />').addClass('popup-error').text(message))
    Popup.refresh()
  },
}

$(Popup.init)
$(window).on('resize', Popup.refresh)
